import { v4 as uuid } from 'uuid';
import { encounterIdA } from '../encounters';
import { Order, OrderType } from '@getvim-os/types';

export const orderE: Order = {
  id: uuid(),
  type: OrderType.LAB,
  icd: [],
  cpts: [
    {
      name: 'EXC COARCJ aorta w/wo PDA w/direct anastomosis',
      code: '33840',
    },
  ],
  encounterId: encounterIdA,
  createdDate: '2000-01-01',
};
